import { Box, IconButton, Popover } from "@mui/material";
import { useState } from "react";
import PrimaryHoverEffect from "src/components/ui/warehouse/primaryHoverEffect";
import SettingsIcon from "src/components/ui/svgIcon/SettingsIcon";
import BioMenu from "./BioMenu";
import { SettingMenuBox } from "../professionalSection/style";

const SystemSection = (menu) => {
  const [anchorElMonitorUser, setAnchorMonitorUserEl] = useState(null);
  // const [anchorElUserData, setAnchorElUserData] = useState(null);
  const openMonitorUser = Boolean(anchorElMonitorUser);
  // const openUserData = Boolean(anchorElUserData);

  const handleClickMonitorUser = (event) => setAnchorMonitorUserEl(event.currentTarget);
  const handleCloseMonitorUser = () => setAnchorMonitorUserEl(null);
  // const handleClickUserData = (event) => setAnchorElUserData(event.currentTarget);
  // const handleCloseUserData = () => setAnchorElUserData(null);
  //const editEnable = menu?.menu[0].node.subMenus.edges.find();

  const id = openMonitorUser ? "simple-popover" : undefined;

  return (
    <>
      <Box height={38}>
        <PrimaryHoverEffect className={openMonitorUser ? "active" : ""}>
          <IconButton onClick={menu?.menu[0]?.node?.menuName === "معرفی سامانه" ? handleClickMonitorUser : null}>
            <SettingsIcon fontSize="small" />
          </IconButton>
        </PrimaryHoverEffect>
      </Box>

      {menu?.menu[0]?.node?.menuName === "معرفی سامانه" && (
        <SettingMenuBox
          id={id}
          open={openMonitorUser}
          anchorEl={anchorElMonitorUser}
          onClose={handleCloseMonitorUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <BioMenu menu={menu} handleClose={handleCloseMonitorUser} />
        </SettingMenuBox>
      )}

      {/* {menu?.menu[0].node.subMenus.edges === "ویرایش حساب کاربری" ? (
        <UserDataModalSection handleClose={handleCloseUserData} open={openUserData} anchorEl={anchorElUserData} />
      ) : null} */}
    </>
  );
};

export default SystemSection;
